import { Info } from 'lucide-react';

import { Alert, AlertDescription } from '@/components/ui/alert';

interface EditChangeAlertProps {
  message: string;
}

/**
 * Alert component shown when editing a historical change record.
 * Informs the user they are in edit change mode.
 * Used by both project and team member detail pages.
 */
export const EditChangeAlert = ({ message }: EditChangeAlertProps) => {
  return (
    <Alert variant="warning">
      <Info className="h-4 w-4" />
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
};
